import dayjs from "dayjs";
import { ALL_START_DATE } from "./constant";

const formatDateOnly = "YYYY-MM-DD";
const defaultStartTime = "00:00:00";
const defaultEndTime = "23:59:59";

const formatDateTime = (date: dayjs.ConfigType, time = defaultStartTime) =>
  `${dayjs(date).format(formatDateOnly)} ${time}`;

const today = dayjs();
const yesterday = dayjs().subtract(1, "day");
const currentDate = dayjs().format(`${formatDateOnly} HH:mm:ss`);
const last7DaysDate = dayjs().subtract(6, "day");
const last30DaysDate = dayjs().subtract(30, "day");

export const predefinedDates = {
  today: {
    startDate: formatDateTime(today),
    endDate: formatDateTime(today, defaultEndTime),
  },
  yesterday: {
    startDate: formatDateTime(yesterday),
    endDate: formatDateTime(yesterday, defaultEndTime),
  },
  last7: {
    startDate: formatDateTime(last7DaysDate),
    endDate: currentDate,
  },
  last30: {
    startDate: formatDateTime(last30DaysDate),
    endDate: currentDate,
  },
  all: {
    startDate: ALL_START_DATE,
    endDate: currentDate,
  },
};

export const DOWNLOAD_TYPES = {
  CSV: "csv",
  PDF: "pdf",
} as const;

export const EXPORT_SELECTION_COLUMNS = {
  ALL_COLUMNS: "all",
  VISIBLE_COLUMNS: "selected",
} as const;
